import type { RouteRecordRaw } from 'vue-router';

export const infoFeatureCategoryRoutes: Array<RouteRecordRaw> = [
  {
    path: '/info/feature/category',
    name: 'infoFeatureCategory',
    redirect: '/info/feature/category/list',
    component: () => import('pages/info/featureCategory/FeatureCategory.vue'),
    meta: {
      title: 'Feature Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'infoFeatureCategoryList',
        component: () => import('pages/info/featureCategory/FeatureCategoryList.vue'),
        meta: {
          title: 'Feature Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'infoFeatureCategoryDetail',
        component: () => import('pages/info/featureCategory/FeatureCategoryDetail.vue'),
        meta: {
          title: 'FeatureCategory Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'infoFeatureCategoryNew',
        component: () => import('pages/info/featureCategory/FeatureCategoryNew.vue'),
        meta: {
          title: 'New FeatureCategory',
          requiresAuth: true,
        },
      },
    ],
  },
];
